export const SORT_CODE_INVALID_MESSAGE = "Sort code must be 6 digits";

export const isCompleteSortCode = (value: string): boolean =>
  /^\d{2}-\d{2}-\d{2}$/.test(value.trim());
